// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"766126a96005b740a5b6","691":"2180049cc6fa695e31aa","883":"5675c5ff1bd7b18dd9a3"}[chunkId] + ".js";
};